import React from 'react';
import css from './QuickFactsRow.module.css';

const CAPTAIN_LABELS = {
  'no-requirements': 'No Captain Required',
  'captain-optional-preapproved': 'Captain Available',
  'captain-required-any': 'Captain Required',
};

const FUEL_INCLUDED_POLICIES = new Set(['fuel-included', 'first-tank-included']);

const FUEL_LABELS = {
  'fuel-included': 'Fuel included',
  'first-tank-included': 'First tank included',
  'return-same-level': 'Return same fuel level',
  'customer-pays-actual': 'Customer pays fuel',
};


const EXPERIENCE_LABELS = {
  'safety-course': 'Safety Course Required',
  'prior-powerboat': 'Prior Experience Required',
  'powerboat-license': 'License Required',
  'asa-101': 'ASA 101 Required',
  'asa-102': 'ASA 102 Required',
  'asa-103': 'ASA 103 Required',
  'asa-104': 'ASA 104 Required',
};

const QuickFactsRow = ({ publicData }) => {
  if (!publicData) return null;

  const {
    boat_length,
    passenger_capacity,
    hired_captain_crew_requirements,
    pickup_options,
    fuel_policy,
    experience_required,
  } = publicData;

  const primaryFacts = [];
  const secondaryFacts = [];

  if (boat_length) {
    primaryFacts.push({ icon: '↔', label: `${boat_length} feet`, key: 'length' });
  }

  if (passenger_capacity) {
    primaryFacts.push({ icon: '👥', label: `${passenger_capacity} guests`, key: 'capacity' });
  }

  if (fuel_policy && FUEL_INCLUDED_POLICIES.has(fuel_policy)) {
    primaryFacts.push({ icon: '⛽', label: FUEL_LABELS[fuel_policy], key: 'fuel' });
  }

  const captainReqs = Array.isArray(hired_captain_crew_requirements)
    ? hired_captain_crew_requirements
    : [];
  const captainKey = ['captain-required-any', 'captain-optional-preapproved', 'no-requirements'].find(
    k => captainReqs.includes(k)
  );
  if (captainKey) {
    secondaryFacts.push({ icon: '⚓', label: CAPTAIN_LABELS[captainKey], key: 'captain' });
  }

  const pickupOpts = Array.isArray(pickup_options) ? pickup_options : [];
  const hasDelivery = pickupOpts.includes('provider-delivers') || pickupOpts.includes('third-party-ok');
  const hasSelfPickup = pickupOpts.includes('board-at-home-base') || pickupOpts.includes('customer-pickup') || pickupOpts.includes('customer-tow-away');
  if (hasDelivery) {
    const deliveryLabel = hasSelfPickup ? 'Delivery Available' : 'Delivery Required';
    secondaryFacts.push({ icon: '🚚', label: deliveryLabel, key: 'delivery' });
  }

  if (experience_required && experience_required !== 'none-required' && EXPERIENCE_LABELS[experience_required]) {
    secondaryFacts.push({ icon: '📋', label: EXPERIENCE_LABELS[experience_required], key: 'experience' });
  }

  if (primaryFacts.length === 0 && secondaryFacts.length === 0) return null;

  const renderRow = (facts, rowKey, threeCol = false) => (
    <div key={rowKey} className={threeCol ? `${css.grid} ${css.gridThree}` : css.grid}>
      {facts.map(({ icon, label, key }) => (
        <div key={key} className={css.cell}>
          <span className={css.cellIcon}>{icon}</span>
          <span className={css.cellLabel}>{label}</span>
        </div>
      ))}
    </div>
  );

  return (
    <div className={css.root}>
      <div className={css.rows}>
        {primaryFacts.length > 0 && renderRow(primaryFacts, 'primary', primaryFacts.length === 3)}
        {secondaryFacts.length > 0 && renderRow(secondaryFacts, 'secondary')}
      </div>
    </div>
  );
};

export default QuickFactsRow;
